export default "__VITE_ASSET__CsFdJYjA__"